import { connect } from 'react-redux';

import { actionCreators, selectors } from 'dux/createInstance';
import AddonCards from './AddonCards';

function mapStateToProps(state) {
  const { newInstanceAddons } = selectors.getCreateInstanceState(state).newInstance;
  return { newInstanceAddons };
}

const mapDispatchToProps = {
  selectAddon: actionCreators.selectAddon,
  deselectAddon: actionCreators.deselectAddon,
  getPrice: actionCreators.getPrice,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddonCards);
